// GLOBAL VARIABLES & CONSTANTS ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //
  
  const rentalForm = document.getElementById('rental-form');
  const rentalFormFields = rentalForm.querySelectorAll('input, select, textarea');
  const rentalStepWrappers = document.querySelectorAll('.rental-step');
  const rentalStartInput = document.getElementById('rentalStartDate');
  const rentalEndInput = document.getElementById('rentalEndDate');
  const rentalDurationSelectors = document.querySelectorAll('[name="attributes[Rental Duration]"]');
  const deliveryMethodInput = document.querySelector(`[name="properties[Delivery Method]"]`);
  const stepStatusSources = document.querySelectorAll('.step-status-source');
  const dobComponentInputs = document.querySelectorAll('.dob-input');
  const clearCartButtons = document.querySelectorAll('.clear-cart-items');
  const addonsComponents = document.querySelectorAll(".rental-addon-tile");
  const addonComponentButtons = document.querySelectorAll(".rental-addon-tile--button");
  let picker;
  let pickerMinDate = new Date().toLocaleDateString('en-CA');
  let pickerMaxDate = product.tags.includes('Snow') ? '2025-06-05' : null;


// LISTENERS ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //

  addToCartButton.disabled = true;

  // listen for form change
  rentalFormFields.forEach(field => {
    field.addEventListener('input', e => {

      // update step statuses
      const step = field.closest('.rental-step');
      if (stepComplete(step)) {
        updateStepStatus(step, true);
      } else {
        updateStepStatus(step, false);
      }

      // if method change, recreate date picker with new min/max dates
      if (field.name === 'properties[Delivery Method]') {
        picker?.destroy();
        const pickerMinDate = field.value.includes('Pick up') ? product.dateTimeData.minDates.pickup
          : field.value.includes('Ship') ? product.dateTimeData.minDates.shipping
          : field.value.includes('Ship') ? product.dateTimeData.minDates.shipping
          : new Date().toLocaleDateString('en-CA');
        createDatePicker(pickerMinDate, pickerMaxDate);
        if (deliveryMethodInput?.value && rentalStartInput?.value && rentalEndInput?.value) checkInventory();
      }

      // validate form
      setTimeout(() => addToCartButton.disabled = rentalFormValid() ? false : true, 500);

    });
  });

  // listen for duration change
  rentalDurationSelectors.forEach(selector => {
    selector.addEventListener('change', () => {

      // set selected variant
      const selectedVariant = selector.dataset.id
      document.querySelector(`[name="id"]`).value = selectedVariant;

      // set end date, if possible
      getEndDate().then(endDate => {
        setEndDate(endDate); // set end date 
        displayDatesInfo(); // display date info to user
      }).then(() => {
        if (deliveryMethodInput?.value && rentalStartInput?.value && rentalEndInput?.value) checkInventory();
      });

      // update addon variant ids
      if (!addonsComponents.length) return;
      addonsComponents.forEach(addon => updateAddonData(addon, selector.value));

    });
  });

  // listen for date field change
  if (rentalEndInput) {
    rentalEndInput.addEventListener('change', () => {        
      const statusDates = getDateRangeString(rentalStartInput.value, rentalEndInput.value);
      const rentalStep = rentalEndInput.closest(".rental-step");
      rentalStep?.querySelector(".step-status")?.setAttribute("data-status", 'complete');
      rentalStep?.querySelector(".step-status")?.setAttribute("data-value", statusDates);
    });
  }

  // listen for complete date of birth
  dobComponentInputs.forEach(input => {
    input.addEventListener('input', () => {
      const dobComplete = Array.from(dobComponentInputs).every(input => input.value);
      if (!dobComplete) return;
      const dobFinalInput = document.querySelector('[name="properties[Renter Date of Birth]"]');
      dobFinalInput.value = dobComponentInputs[0].value + '-' + dobComponentInputs[1].value + '-' + dobComponentInputs[2].value;
    });
  });

  // listen for clear cart request
  clearCartButtons.forEach(button => {
    button.addEventListener('click', () => {
      removeRentalItemsFromCart();
    });
  });

  addonComponentButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const addon = e.target.closest(".rental-addon-tile");
      const addonOptionSelector = addon.querySelector(`select`);
      if (!addonOptionSelector || !addonOptionSelector.value) {
        addonOptionSelector.classList.add("invalid");
        setTimeout(() => addonOptionSelector.classList.remove("invalid"), 3000);
        return;
      }
      addon.classList.toggle("added");
      addAddon(addonOptionSelector);
    });
  });

  // listen for delivery method change
  deliveryMethodInput.addEventListener('change', () => {
    if (deliveryMethodInput.value && rentalStartInput?.value && rentalEndInput.value) checkInventory();
  });

  // on document ready
  document.addEventListener("DOMContentLoaded", async () => {

    if (product.tags.includes('EFA')) {
      checkInventory();
      return;
    }

    // if rental product unavailable for cart dates, hide form
    const cart = await getCart();
    const cartRentalStart = cart.attributes["Rental Start Date"];
    const cartRentalEnd = cart.attributes["Rental End Date"];
    hasBlackoutDates(cartRentalStart, cartRentalEnd, product.dateTimeData.blackoutDates) ? rentalForm.style.display = 'none' : rentalForm.style.display = 'block';

    createDatePicker(pickerMinDate, pickerMaxDate);
    if (rentalStartInput.value && rentalEndInput.value) {
      const statusDates = getDateRangeString(rentalStartInput.value, rentalEndInput.value);
      const rentalStep = rentalEndInput.closest(".rental-step");
      rentalStep?.querySelector(".step-status")?.setAttribute("data-status", "complete");
      rentalStep?.querySelector(".step-status")?.setAttribute("data-value", statusDates);
    }
    setTimeout(() => { openFirstIncompleteStep(); }, 1000);

    if (addonsComponents.length) {
      const selectedVariant = product.variants.find(variant => variant.id === document.querySelector(`[name="id"]`).value);
      addonsComponents.forEach(addon => updateAddonData(addon, selectedVariant));
    }
  });
  

// FUNCTIONS >> Date Picker -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //

  async function createDatePicker(minDate, maxDate) {

    if (!rentalStartInput) return;
    
    // set min/max date defaults if no input
    minDate = !minDate || minDate && new Date(minDate) < new Date() ? new Date().toLocaleDateString('en-CA') : minDate;
    maxDate = maxDate ? maxDate : new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toLocaleDateString('en-CA');

    // if minDate is today and is after rental cutoff, set minDate to tomorrow
    if (minDate === new Date().toLocaleDateString('en-CA') && isAfterRentalCutoff()) {
      minDate = new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleDateString('en-CA');
    }
    
    // check for target input
    if(!rentalStartInput) return;

    // create date picker
    picker = new easepick.create({
      element: rentalStartInput,
      css: [
        easepickCssUrl,
      ],
      firstDay: 0,
      plugins: ['LockPlugin'],
      LockPlugin: {
        minDate: minDate,
        maxDate: maxDate,
        filter: (date, picked) => {
          for (const blackoutDay of product.metadata.blackoutDates) {
            const lockedDate = new Date(`${blackoutDay}T00:00:00`);
            if (date.isSame(lockedDate, 'day')) return true;
          }
          return false;
        }
      },
      async setup(picker) {
        const cart = await fetchCart();
        console.log("cart", cart.attributes['Rental Start Date']);
        rentalStartInput.value = cart.attributes['Rental Start Date'] || ''; // set initial value
        displayDatesInfo(); // clear date info
        picker.gotoDate(minDate); // scroll to first available date
        picker.on('select', (e) => {
          document.querySelector('[name="attributes[Rental Start Date]"]').value = e.detail.date.toISOString().split('T')[0];
          getEndDate().then(endDate => {
            setEndDate(endDate); // set end date 
            displayDatesInfo(); // display date info to user
            if (deliveryMethodInput.value && rentalStartInput.value && rentalEndInput.value) checkInventory(); // if delivery method and dates are set, check inventory
            addToCartButton.disabled = rentalFormValid() ? false : true; // validate rental form
          });
        });
      },
    });
  }


// FUNCTIONS >> Date Management ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //

  function addDaysToDateString(dateString, daysToAdd) {
    if (!dateString || !daysToAdd) return;
    daysToAdd = parseInt(daysToAdd);
    if (isNaN(daysToAdd)) return;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) throw new Error('Invalid date format. Please use YYYY-MM-DD format.'); // Validate input
    const [year, month, day] = dateString.split('-').map(Number); // Split date into year, month, day
    const date = new Date(Date.UTC(year, month - 1, day)); // Create a UTC date to avoid timezone issues; Month is 0-indexed in JavaScript, so subtract 1 from month
    if (isNaN(date.getTime())) throw new Error('Invalid date. Please check the date values.'); // Validate date   
    date.setUTCDate(date.getUTCDate() + daysToAdd);  // Add the specified number of days using UTC methods
    const newYear = date.getUTCFullYear(); // get year
    const newMonth = String(date.getUTCMonth() + 1).padStart(2, '0'); // Add 1 to month (0-indexed) and pad with leading zero if needed
    const newDay = String(date.getUTCDate()).padStart(2, '0'); // Pad day with leading zero if needed
    return `${newYear}-${newMonth}-${newDay}`; // Return result as YYYY-MM-DD
  }

  function getDateRangeString(start, end) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(start) || !/^\d{4}-\d{2}-\d{2}$/.test(end)) throw new Error('Invalid date format. Please use YYYY-MM-DD format.'); // Validate input

    const [startYear, startMonth, startDay] = start.split('-').map(Number); // Split start date into year, month, day
    const [endYear, endMonth, endDay] = end.split('-').map(Number); // Split end date into year, month, day
    const startDate = new Date(Date.UTC(startYear, startMonth - 1, startDay)); // Create a UTC date to avoid timezone issues; Month is 0-indexed in JavaScript, so subtract 1 from month
    const endDate = new Date(Date.UTC(endYear, endMonth - 1, endDay)); // Create a UTC date to avoid timezone issues; Month is 0-indexed in JavaScript, so subtract 1 from month
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) throw new Error('Invalid date. Please check the date values.'); // Validate date
    if (startDate > endDate) throw new Error('Start date is after end date.'); // Validate start date is before end date

    // if start date month and end date month are the same, return start date to end date
    if (startDate.getMonth() === endDate.getMonth()) {
      return `${startDate.toLocaleDateString("en-US", { month: "short" })} ${startDay} - ${endDay}`
    }
    return `${startDate.toLocaleDateString("en-US", { month: "short" })} ${startDay} - ${endDate.toLocaleDateString("en-US", { month: "short" })} ${endDay}`
  }

  async function getEndDate() {
    const start = picker.getDate();
    const selectedDurationInput = document.querySelector('[name="attributes[Rental Duration]"]:checked');
    if (!start || !selectedDurationInput) return;
    const rentalDuration = selectedDurationInput.dataset.rentalDuration;
    const rentalDurationIsDate = /^\d{4}-\d{2}-\d{2}$/.test(rentalDuration);
    if (rentalDurationIsDate) return rentalDuration; // if duration is fixed end date, return that date


    // duplicate rentalStartDate as rentalEndDate
    const end = picker.getDate();
    end.setDate(end.getDate() + Number(rentalDuration) + 1);
    return end.toISOString().split('T')[0];
  }

  function longDateString(dateString) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) throw new Error('Invalid date format. Please use YYYY-MM-DD format.'); // Validate input
    const [year, month, day] = dateString.split('-').map(Number); // Split date into year, month, day
    const date = new Date(Date.UTC(year, month - 1, day)); // Create a UTC date to avoid timezone issues; Month is 0-indexed in JavaScript, so subtract 1 from month
    if (isNaN(date.getTime())) throw new Error('Invalid date. Please check the date values.'); // Validate date
    return `${date.toLocaleDateString('en-US', { weekday: 'long' })}, ${date.toLocaleString('en-US', { month: 'long' })} ${day}, ${year}`; // Return result as long date string
  }

  function setEndDate(endDate) {
    if (!endDate) return;
    rentalEndInput.value = endDate; // update value
    document.querySelector('[name="attributes[Rental End Date]"]').value = endDate;
    rentalEndInput.dispatchEvent(new Event('change')); // trigger date change listener
    return true;
  }

  function displayDatesInfo() {
    const dateInfoWrapper = document.getElementById('dates-info');
    const startDate = document.querySelector('[name="properties[Rental Start Date]"]').value;
    const endDate = document.querySelector('[name="properties[Rental End Date]"]').value;
    if (!dateInfoWrapper) return;
    if (!startDate || !endDate) {
      dateInfoWrapper.innerHTML = '';
      return
    };
    const freeDaysText = !product.tags.includes('Bike') ? '<li><i>Dates include free pick up and return days.</i></li>' : '';
    dateInfoWrapper.innerHTML = `
      <ul class="list-dash text-sb-green text-sm">
        <li><strong>Start Date</strong>: ${longDateString(startDate)}</li>
        <li><strong>End Date</strong>: ${longDateString(endDate)}</li>
        ${freeDaysText}
      </ul>
    `;
  }

  function hasBlackoutDates(startStr, endStr, blackoutDates) {

    if (!startStr || !endStr || !blackoutDates) return false; // Check if any of the inputs are empty
    
    // Convert strings to Date objects
    const start = new Date(startStr);
    const end = new Date(endStr);
    
    // Loop through each date from start to end (inclusive)
    const currentDate = new Date(start);
    while (currentDate <= end) {
      // Format current date as string in YYYY-MM-DD format
      const dateStr = currentDate.toISOString().split('T')[0];
      
      // Check if the current date is in the blackout dates
      if (blackoutDates.includes(dateStr)) {
        return true;
      }
      
      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }
    
    // No blackout dates found
    return false;
  }
  
  
// FUNCTIONS >> Step Management ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //

  function rentalFormValid() {
    let formValid = true;
    let i = 0;
    do {
      formValid = stepComplete(rentalStepWrappers[i]);
      i++;
    } while (formValid && i < rentalStepWrappers.length);
    return formValid;
  }

  function openFirstIncompleteStep() {
    let openStep = Array.from(rentalStepWrappers).find(wrapper => wrapper.querySelector('.card-header[aria-expanded="true"]'));
    i = 0;
    do {
      let step = rentalStepWrappers[i];
      if (stepComplete(step)) {
        updateStepStatus(step, true);
      } else {
        step.querySelector('.card-header').click();
        openStep = true;
      }
      i++;
    } while (!openStep && i < rentalStepWrappers.length);
  }

  function stepComplete(stepWrapper) {
    const stepFields = stepWrapper.querySelectorAll('input, select, textarea');
    const incompleteRequiredFields = Array.from(stepFields).filter(field => !field.value && field.required);
    const stepComplete = incompleteRequiredFields.length === 0;
    if (stepComplete) updateStepStatus(stepWrapper, true);
    console.log(`Step ${stepWrapper.dataset.step} complete: ${stepComplete}`, incompleteRequiredFields);
    return stepComplete;
  }

  function updateStepStatus(step, complete) {

    if (!step) return; // if no step, abort
    const stepStatus = step.querySelector('.step-status');
    
    // if step incomplete update status
    if (!complete) {
      stepStatus.setAttribute('data-status', 'in-progress');
      stepStatus.setAttribute('data-value', `Step ${step.dataset.step} Incomplete`);
      return;
    }

    // if step complete get step status value and update step status display
    if (stepStatus && stepStatus.dataset.status === 'not-started' || stepStatus.dataset.status === 'in-progress') {
      const stepStatusSource = step.querySelector('.step-status-source');
      const statusText = stepStatusSource ? stepStatusSource.value || stepStatusSource.dataset.completeStatus : 'Complete';
      stepStatus.setAttribute('data-status', 'complete');
      stepStatus.setAttribute('data-value', statusText);
    }

  }

  function userShortName() {
    const firstName = document.querySelector('[name="properties[Renter First Name]"]')?.value;
    const lastName = document.querySelector('[name="properties[Renter Last Name]"]')?.value;
    if (!firstName || !lastName) return;
    return `${firstName} ${lastName[0]}.`;
  }

  addToCartButton.onclick = async (e) => {
    e.preventDefault();
    const cartInput = await buildCartJson();
    addRentalToCart(cartInput);
  }

// FUNCTIONS >> Rental Addons ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ //

  function addAddon(addon) {
    if (!addon) return;
    const addon_rental_group_id = addon.dataset.rentalGroupId;
    const addon_model_id = addon.dataset.modelId;
    const addon_upgrade_target = addon.dataset.upgradeTarget;
    const addon_property1 = addon.value;

    // populate addon data
    const addon_inputs = Array.from(addon.parentNode.children).filter(element => element.tagName === 'INPUT');
    addon_inputs.forEach(input => {
      if (!input.name.includes("addon[")) return;
      if (input.name.includes("Rental Group ID") && addon_rental_group_id) input.value = addon_rental_group_id;
      if (input.name.includes("Model ID") && addon_model_id) input.value = addon_model_id;
      if (input.name.includes("Option") && addon_property1) input.value = addon_property1;
      if (input.name.includes("Upgrade Target") && addon_upgrade_target) input.value = addon_upgrade_target;
    });
  }

  function updateAddonData(addon, variant_name) {
    if (!addon || !variant_name) return;
    fetch(`/products/${addon.dataset.productHandle}.js`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then(product => {
        const addon_variant = product.variants.find(variant => variant.title === variant_name);
        if (!addon_variant) throw new Error(`Variant not found: ${variant_name}`);
        const addonSelect = addon.querySelector(".rental-addon-tile--select");
        if (!addonSelect) throw new Error("Cannot find .rental-addon-tile--select element");
        addonSelect.setAttribute("data-variant-id", addon_variant.id);
        const addonPrice = addon.querySelector(".rental-addon-tile--price");
        if (!addonPrice) throw new Error("Cannot find .rental-addon-tile--price element");
        addonPrice.innerHTML = `<small>$</small>${addon_variant.price / 100}`;
      })
      .catch(error => {
        console.error('Error fetching the addon product:', error);
      });
  }




// FUNCTIONS >> Inventory Check ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //

  function getOrderLeadTime() {
    if (!rentalStartInput || !rentalEndInput || !rentalStartInput.value ||!rentalEndInput.value) return null;
    const orderLeadTime = new Date(rentalStartInput.value)
    const rightNow = new Date();
    const daysDifference = Math.ceil((orderLeadTime - rightNow) / (1000 * 60 * 60 * 24));
    return daysDifference;
  }

  function getInventoryRequestData() {
    if (!rentalStartInput || !rentalEndInput || !rentalStartInput.value ||!rentalEndInput.value) return null;
    let inventoryRequestData = []
    const selectedBranchId = product.tags.includes("EFA") ? '2' : document.querySelector('input[name="secondary-selector--store"]:checked')?.dataset.erBranchId;
    const sbriRequired = document.querySelectorAll(".sbri-required");
    const region = !selectedBranchId ? null : selectedBranchId === "35" || selectedBranchId === "40" ? "SoCal" : "Bay Area";
    const branchId = getOrderLeadTime() <  7 && region === "SoCal" ? selectedBranchId 
      : getOrderLeadTime() < 2 ? selectedBranchId 
      : "0";

    sbriRequired.forEach(el => {        
      const data = {...el.dataset};
      data.datefrom = rentalStartInput.value;
      data.dateto = rentalEndInput.value;
      data.er_branchid = branchId; 
      inventoryRequestData.push(data);
    });
    return inventoryRequestData
  }

  async function getInventoryResponse(input) {
    // console.log("inventory check input: ", input);
    if (!input) return;
    try {

      // fetch inventory data
      const response = await fetch("http://koda.sportsbasement.com/sbri/sbrents", {
        method: "POST",
        cache: "no-cache",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json",
        },
        referrerPolicy: "no-referrer",
        body: JSON.stringify(input),
      });

      // log error and abort if response is not ok
      if (!response.ok) {
        console.error("Error checking inventory:", response.statusText);
        return;
      }

      // process response if response is ok
      const inventoryData = await response.json();
      console.log("Inventory response:", inventoryData);
      return inventoryData;
    } catch (error) {
      console.error("Error checking inventory:", error);
    }
  }

  async function processInventoryResponse(input) {
  
    if (!input || !input.getavailresult) {
      console.log("No inventory data available.");
      return; // exit if input or getavailresult is not defined
    }
    
    const threshold = 1; // set minimum inventory threshold

    // if all options out of stock
    const allOptionsOutOfStock = input.getavailresult.every(item => parseInt(item.availcount) < threshold);

    if (allOptionsOutOfStock) {
      addToCartButton.disabled = true;
      rentalFormFields.forEach(field => field.disabled = true);
      return;
    }

    // for each item in getavailresult, if availcount < threshold, disable options that have a value equlal to the item.property1
    input.getavailresult.forEach(response => {
      const availCount = parseInt(response.availcount);
      const targets = document.querySelectorAll(`[data-er_modelid="${response.er_modelid}"][value="${response.property1}"]`);
      
      // if available, enable option
      if (availCount >= threshold) targets.forEach(target => target.disabled = false); 

      // if unavailable, disable option and deselect if necessary
      targets.forEach(target => {
        if (availCount < threshold) {
          target.disabled = true;
          target.innerText = `${target.innerText.replace(" - Unavailable", "")} - Unavailable`;
          if (target.selected) {
            target.selected = false;
            target.parentElement.children[0].selected = true;
            target.parentElement.classList.add("error");
            addToCartButton.disabled = true;
          }
        } else {
          target.disabled = false;
          target.innerText = target.innerText.replace(" - Unavailable", "");
        }
      }); 

    });
    
    return true;
  }

  async function checkInventory() {
    console.log("Checking inventory...");
    const inventoryRequestData = getInventoryRequestData();
    const inventoryResponse = await getInventoryResponse(inventoryRequestData);

    // process inventory response then enable or disable add to cart button
    processInventoryResponse(inventoryResponse).then((someOptionsAvailable) => {
      if (!someOptionsAvailable) {
        addToCartButton.disabled = true;
        addToCartButton.classList.add("locked");
        return;
      }
      openFirstIncompleteStep();
      addToCartButton.disabled = rentalFormValid() ? false : true;
      addToCartButton.classList.remove("locked");
    });
  }
  
// FUNCTIONS >> Cart manipulation -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //

  function removeRentalItemsFromCart() {
    // First, fetch the current cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        // Filter out attributes containing the word "Rental"
        const rentalAttributes = Object.keys(cart.attributes)
          .filter(key => key.includes("Rental"))
          .reduce((result, key) => {
              result[key] = '';
              return result;
          }, {});

        // Filter out line items with the vendor "SB Rentals"
        const rentalItems = cart.items.filter(item => item.vendor === "SB Rentals");

        // Prepare the cart data for updating
        const updates = {
          attributes: rentalAttributes,
          updates: rentalItems.reduce((result, item) => {
              result[item.key] = 0;
              return result;
          }, {})
        };

        // Send the updated cart data to the /cart/update.js endpoint
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(updates)
        });
      })
      .then(response => response.json())
      .then(updatedCart => {
        // console.log('Cart updated successfully:', updatedCart);
        window.location.reload();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    
  }

  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Shopify cart.js response was not ok', response);
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error('Unable to fetch cart:', error);
    }
  }

  async function buildCartJson() {
    // get existing cart rental json attribute
    const cart = await fetchCart();
    
    // capture user info and update stored renter profiles
    const newProfile = captureRenterProfile(rentalForm);
    const oldProfile = findExistingRenterProfile(newProfile);
    newProfile && oldProfile ? updateRenterProfile(newProfile, oldProfile) : createNewRenterProfile(newProfile);

    // define starting variables
    const formData = new FormData(rentalForm);
    const package_id = new Date().getTime();
    
    // build holding arrays for data
    const universalProperties = { 'Package ID': package_id };
    const addonItems = [];
    const rentalItem = {
      id: null,
      'properties': { 'Package ID': package_id }
    }

    const cartInput = {
      'attributes': {},
      'items': []
    }

    // create an object from form data
    const formDataObject = Object.fromEntries(formData.entries());

    // remove empty attributes from formDataObject
    for (const key in formDataObject) {
      if (formDataObject.hasOwnProperty(key)) {
        if (formDataObject[key] === "") delete formDataObject[key];
      }
    }

    // loop through each key/value pair in formDataObject
    for (const key in formDataObject) {

      // define constants
      const value = formDataObject[key];
      const keyArray = key.replaceAll("]", "").split("[");

      // capture variant id
      if (key === "id") rentalItem.id = parseInt(value);
      
      // capture cart attributes
      if (key.startsWith("attributes[")) {
        cartInput.attributes[keyArray[1]] = value;
      }

      // capture product properties
      if (key.startsWith("properties[")) {
        rentalItem.properties[keyArray[1]] = value;
        if (keyArray[1].startsWith("Rent") || keyArray[1] === "Delivery Method") universalProperties[keyArray[1]] = value;
      }

      // capture addon properties
      if (key.startsWith("addon[")) {
        const addonId = Number(document.querySelector(`select[name="${handleize(keyArray[2])}-addon"]`).getAttribute('data-variant-id'));
        const addonExists = addonItems.some(item => item.id === addonId);
        if (!addonExists) addonItems.push({
          id: addonId,
          properties: {} 
        });
        const item = addonItems.find(item => item.id === addonId)
        item.properties[`${keyArray[2]} ${keyArray[1]}`] = value;
      }
    }

    // set rental expiration date
    const deliveryMethod = formDataObject["properties[Delivery Method]"];
    
    const leadtime = deliveryMethod.includes("Pick up") ? product.dateTimeData.pickupLeadTime 
      : deliveryMethod.includes("DoorDash") ? product.dateTimeData.doordashLeadTime 
      : product.dateTimeData.shipLeadTime;
    rentalItem.properties["Rental Expiration"] = setRentalExpiration(rentalItem.properties["Rental Start Date"], leadtime);
    universalProperties["Rental Expiration"] = setRentalExpiration(rentalItem.properties["Rental Start Date"], leadtime);
    
    // add items to cart input
    cartInput.items.push(rentalItem);
    addonItems.forEach(item => { 
      item.properties = { ...item.properties, ...universalProperties }; 
      cartInput.items.push(item);
    });

    return cartInput;
  }

  function addRentalToCart(cartInput) {
    // console.log("cartInput: ", cartInput);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(cartInput)
    }).then(response => response.json()).then(cart => {
      updateCartCountDisplay(cartInput.items.length);
      const button = $('#add-to-bag');
      animateAddToBagButton(button);
      window.location.href = '/cart';
      // window.location.reload();
    }).catch(error => {
      console.error('There was a problem adding the rental to the cart:', error);
      console.error('cartInput error: ', cartInput);
    });
  }

  function setRentalExpiration(startDate, leadtime) {
    if (!startDate) return;
    startDate = new Date(startDate).getTime();
    leadtime = leadtime ? leadtime * 86400 : 3 * 86400;
    const expirationDate = new Date(startDate - leadtime);

    // convert expiration date to YYYY-MM-DD
    const expirationDateStr = expirationDate.toISOString().split('T')[0];

    return expirationDateStr
  }